import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, FormGroup, Input, Row, Modal, UncontrolledTooltip } from "reactstrap";
import EditButton from "./EditButton";
import CreatableSelect from 'react-select/creatable';
import ReactDatetime from "react-datetime";
import moment from 'moment';

const PersonelArchiveTable = ({ personel, opk, typeLoading, submitEdit, displayUnit, handleCreateUnit }) => {
    const valueConvert = (val) => {
        let nr = Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
        return nr === "NaN" ? " X " : nr
    }
    const [idtoEditArchive, setIdEditArchive] = React.useState(null)
    const [formValuesEditArchive, setFormValuesEditArchive] = React.useState({
        "rate_hour_edit": '',
        "rate_min_edit": '',
        "rate_proc_edit": '',
        "staff_type_edit": '',
        "procedurestaff_opk_edit": '',
        'date_staff_edit':""
    })
    const [idtoEdit, setIdEdit] = React.useState(null)
    const setIdelement = (elem) => {
        let temp = {
            rate_hour_edit: elem.rate_hour,
            rate_min_edit: elem.rate_min,
            rate_proc_edit: elem.rate_proc,
            staff_type_edit: elem.staff_type,
            procedurestaff_opk_edit: elem.procedurestaff_opk,
            date_staff_edit: elem.date_staff=='1900-01-01'?'':elem.date_staff
        }
        setIdEditArchive(elem.id, setFormValuesEditArchive(temp))
    }
    const changeValueInEditForm = (e) => {
        setFormValuesEditArchive((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[e.target.id] = e.target.value;
            return prevLoginValues;
        });
    }
    const handleEdit = (id) => {
        submitEdit(formValuesEditArchive, idtoEditArchive)
        setIdEditArchive(null)
    }
    const changeStawka = (e) => {
        const fieldValue = e.target.value;
        // const fieldIndex = e.target.id

        setFormValuesEditArchive((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues['rate_min_edit'] = (fieldValue / 60).toFixed(2);
            return prevLoginValues;
        });
    }

    return (
        <table className='table table-border tableWycena'>
            <thead className=''>
                <tr className=''>
                    <th className="headerColor">Numer OPK proceduralnego</th>
                    <th className="headerColor">Kategoria personelu</th>
                    <th className="headerColor">Średnia stawka w zł/godz.<br></br>(brutto z pochodnymi)</th>
                    <th className="headerColor">Średnia stawka w zł/minuta<br></br>(brutto z pochodnymi)</th>
                    <th className="headerColor">Średnia stawka w zł/procedurę<br></br>(brutto z pochodnymi)</th>
                    <th className="headerColor">Data obowiązywania</th>
                    <th className="headerColor">Opcje</th>
                </tr>
            </thead>
            <tbody>
                {personel && Object.getOwnPropertyNames(personel).length !== 0 && personel.map((elem) => {
                    return <>
                        {idtoEditArchive !== elem.id ? <tr>
                            <td>{opk ? opk[elem.procedurestaff_opk] : ""}</td>
                            <td>{[elem.staff_name]}</td>
                            <td className='rightAlignCell'>{valueConvert(elem.rate_hour)}</td>
                            <td className='rightAlignCell'>{valueConvert(elem.rate_min)}</td>
                            <td className='rightAlignCell'>{valueConvert(elem.rate_proc)}</td>
                            <td className='rightAlignCell'>{elem.date_staff !== '1900.01.01'?elem.date_staff:""}</td>
                            {idtoEditArchive !== elem.id ? <td style={{ whiteSpace: 'nowrap' }} className='text-center'>
                                <EditButton idx={elem.id} elem={elem} edit={setIdelement} />
                                {/* <DeleteButton idx={elem.id}
                                    id={elem.id}
                                    deleteFunc={deletePersonel}
                                    text={"zasób osobowy?"} /> */}
                                    </td> : <td>
                                <span style={{ marginRight: "5px", cursor: "pointer" }} onClick={() => {
                                    setIdEditArchive(null)
                                }}>
                                    Anuluj</span>&nbsp;&nbsp;<span style={{ marginLeft: "5px" }}>OK</span></td>}
                        </tr> : <tr>
                            <td>
                                <Input type="select" name="opk" placeholder="wybierz opk" id="procedurestaff_opk_edit"
                                    value={formValuesEditArchive['procedurestaff_opk_edit']}
                                    onChange={(e) => changeValueInEditForm(e)}>
                                    <option value=''></option>
                                    {opk && Object.entries(opk).map(([key, value], i) => {
                                        return <option value={key}>{value}</option>
                                    })}
                                </Input>
                            </td>
                            <td><CreatableSelect
                                className='select-wycena'
                                isDisabled={typeLoading}
                                isLoading={typeLoading}
                                placeholder={"Wybierz..."}
                                formatCreateLabel={function formatCreateLabel(inputValue) {
                                    return "Dodaj \"".concat(inputValue, "\"");
                                }}
                                onChange={e => {
                                    setFormValuesEditArchive((prevState) => {
                                        // setDisplayUnit(e.label)
                                        const prevLoginValues = { ...prevState };
                                        prevLoginValues["staff_type_edit"] = e.value;
                                        return prevLoginValues;
                                    });

                                }}
                                onCreateOption={e => handleCreateUnit(e)}
                                options={displayUnit}
                                value={displayUnit.find(item => item.value === formValuesEditArchive['staff_type_edit'])}
                            />
                            </td>
                            <td><Input
                                className="border-input"
                                type="number"
                                id="rate_hour_edit"
                                value={formValuesEditArchive['rate_hour_edit']}
                                onChange={(e) => {
                                    changeValueInEditForm(e)
                                    changeStawka(e)
                                }}

                            /></td>
                            <td><Input
                                className="border-input"
                                type="text"
                                id="rate_min_edit"
                                value={formValuesEditArchive['rate_min_edit']}
                                disabled

                            /></td>
                            <td className='rightAlignCell'><Input
                                className="border-input"
                                type="number"
                                id="rate_proc_edit"
                                value={formValuesEditArchive['rate_proc_edit']}
                                onChange={(e) => {
                                    changeValueInEditForm(e)
                                }}
                            /></td>
                            <td>
                            <ReactDatetime
                                inputProps={{
                                    className: "form-control",
                                    placeholder: "data obowiązywania",
                                }}
                                dateFormat={"YYYY-MM-DD"}
                                timeFormat={false}
                                locale="pl"
                                id='date_staff_edit'
                                onChange={(e) => {
                                    changeValueInEditForm({'target': {value: moment(e).format('YYYY-MM-DD'), id: 'date_staff_edit'}})
                                }}
                                value={formValuesEditArchive['date_staff_edit']}
                                className='dateSelectWycena'
                            />
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }} className='text-center'>
                                <Button
                                    className="btn-link "
                                    color="danger"
                                    data-toggle="tooltip"
                                    size="sm"
                                    type="button"
                                    onClick={() => {
                                        setIdEditArchive(null)
                                    }}
                                >
                                    <i className="fas fa-times"></i>
                                </Button>
                                <Button
                                    className="btn-link "
                                    color="success"
                                    data-toggle="tooltip"
                                    size="sm"
                                    type="button"
                                    onClick={(e) => {
                                        handleEdit(elem.id)
                                    }}
                                >
                                    <i className="fas fa-check"></i>
                                </Button>
                            </td>
                        </tr>}

                    </>
                })}
            </tbody>
        </table>
    )
}
export default PersonelArchiveTable;
